module.exports = __webpack_public_path__ + "static/media/barGraph.4cbeb04b.png";